import { Big } from 'big.js';
import { bigToString, parseBig, QuoteService } from 'quote-domain-core';
import { PricingItemPriceService } from '../pricing-item/pricing-item-price-service';
import { singleton } from 'tsyringe';

@singleton()
export class QuoteServiceTotalPriceService {
    constructor(private readonly pricingItemPriceService: PricingItemPriceService) {
    }

    public calculateAdditionalStockAmount(quoteService: QuoteService): void {
        let additionalStockAmount = new Big(0);
        (quoteService.customGroups ?? []).forEach(customGroup => {
            (customGroup.pricingItems ?? []).forEach(pricingItem => {
                additionalStockAmount = additionalStockAmount.plus(this.pricingItemPriceService.getAdditionalStockAmount(pricingItem));
            });
        });
        Object.assign(quoteService, { additionalStockAmount: bigToString(additionalStockAmount) });
    }

    public calculateCustomGroupTotalAppliedPrice(quoteService: QuoteService): void {
        (quoteService.customGroups ?? []).forEach(customGroup => {
            (customGroup.pricingItems ?? []).forEach(pricingItem => {
                this.pricingItemPriceService.calculateTotalAppliedPrice(pricingItem);
            });
            const totalAppliedPrice = (customGroup.pricingItems ?? []).reduce(
                (acc: Big, pricingItem) => acc.add(parseBig(pricingItem.totalAppliedPrice)),
                new Big(0)
            );
            Object.assign(customGroup, { totalAppliedPrice: bigToString(totalAppliedPrice) });
        });
    }
}
